import React from 'react';
import Header from '../../../../components/layout/headers/Header'
import Sidebar from '../../../../components/layout/navigation/sidebar/DynamicSidebar';
import ApprovePolicyTable from './ApprovePolicyTable'

const ApprovePolicyPage = () => {
    return (
        <>
            <Header />
            <Sidebar />
            <div className="content-body">
                <div className="w-full px-4">
                    <ApprovePolicyTable  />
                </div>
            </div>
        </>
    );
}

export default ApprovePolicyPage ;